import script from "./SearchFacetColorSwatch.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchFacetColorSwatch.vue?vue&type=script&lang=ts&setup=true"

import "./SearchFacetColorSwatch.vue?vue&type=style&index=0&id=dd6f8cee&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd6f8cee"]])

export default __exports__